import { useContext } from 'react';

import UserContext from 'app/common/UserContext';

const useTheme = (): Exclude<DashboardTheme, 'auto'> => {
  const { preferences } = useContext(UserContext);

  if (preferences.theme === 'auto') {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  }

  return preferences.theme;
};

export { useTheme };
